import { formatDate } from '@/lib/time';

// Presentación de los campos propios (QA F1 #14), una sola regla para la ficha, la
// Lista Maestra y Configuración › Catálogos: el valor legible según su tipo, el
// nombre del tipo y la clave interna que se deriva de la etiqueta (el usuario nunca
// escribe claves técnicas, UX-COPY-01).

const EMPTY = '—';
// Sin separador de miles y sin notación científica: lo que se ve es lo que se escribe
// en el formulario (coma decimal), sin ambigüedad entre "12.345" y 12,345.
const NUMBER = new Intl.NumberFormat('es', { useGrouping: false, maximumFractionDigits: 20 });

/** Valor legible: Sí/No, fecha como el resto de la app, número con coma decimal. */
export function formatCustomValue(dataType: string, value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return EMPTY;
  }
  if (dataType === 'boolean' && typeof value === 'boolean') {
    return value ? 'Sí' : 'No';
  }
  if (dataType === 'number' && typeof value === 'number') {
    return NUMBER.format(value);
  }
  if (dataType === 'date' && typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return formatDate(value);
  }
  // Solo valores primitivos se muestran como texto; otra forma es un dato inesperado.
  return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean'
    ? String(value)
    : EMPTY;
}

const TYPE_LABELS: Record<string, string> = {
  text: 'Texto',
  number: 'Número',
  date: 'Fecha',
  boolean: 'Sí o no',
  select: 'Lista de opciones',
};

export function dataTypeLabel(dataType: string): string {
  return TYPE_LABELS[dataType] ?? 'Otro tipo';
}

const KEY_MAX = 60;

/** Clave interna a partir de la etiqueta: sin tildes, minúsculas y guiones bajos;
 *  si empieza con un dígito se antepone "c_". Vacía si la etiqueta no tiene letras
 *  ni dígitos (el formulario lo trata como etiqueta inválida). */
export function fieldKeyFromLabel(label: string): string {
  const base = label
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  if (base === '') {
    return '';
  }
  const prefixed = /^[a-z]/.test(base) ? base : `c_${base}`;
  const key = prefixed.slice(0, KEY_MAX).replace(/_+$/, '');
  // "constructor" se leería heredada de Object: el API la reserva.
  return key in Object.prototype ? `${key.slice(0, KEY_MAX - 6)}_campo` : key;
}
